/**
* @ngdoc service
* @name  phoenix.clipboardService
* 
* @description 
* A service used to wrap clipboard.js as an injectable Angular dependecy.
* Removes the global constructor after bootstrap.
**/
export function ClipboardServiceFactory($window) {
	let instance = null;
	let Clipboard = $window.Clipboard;

	// clear global reference
	$window.Clipboard = null;
	delete $window.Clipboard;

	return {
		/**
		* @ngdoc method
		* @name clipboardService#init
		* @methodOf phoenix.clipboardService
		* @kind function
		*
		* @description
		* Initializes clipboard functionality and instantiates a singleton instance.
		* 
		* @param {string} A DOM selector string.
		*
		*/
		init,
		/**
		* @ngdoc method
		* @name clipboardService#copy
		* @methodOf phoenix.clipboardService
		* @kind function
		*
		* @description
		* Attempts to copy the provided value to the clipboard.
		* 
		* @param {string} A value whose string representation is to be copied to the clipboard.
		*
		*/
		copy,
		/**
		* @ngdoc property
		* @name clipboardService#init#clipboard
		* @propertyOf phoenix.clipboardService
		* @kind property
		*
		* @description
		* The instantiated Clipboard instance.
		* 
		* @returns {Clipboard} A Clipboard object.
		*/
		get clipboard() {
			return instance;
		}
	};

	function init(selector:string) {
		if (!instance) {
			if (!Clipboard) {
				throw new Error('Clipboard.js not available.');
			}

			instance = new Clipboard(selector);
		}
	}

	// data-clipboard-text doesn't work on Angular directives
	function copy(value:string) {
		let body = angular.element($window.document.body);
		let textarea = document.createElement('textarea');

		angular
			.element(textarea)
			.css({
				position: 'fixed',
				opacity: 0
			})
			.val(value);

		body.append(textarea);
		textarea.select();

		try {
			$window.document.execCommand('copy');
		}
		catch (e) {
			throw new Error('Failed to copy to clipboard.');
		}
		
		textarea.remove();
	}
}

ClipboardServiceFactory.$inject =  [
	'$window'
];


// WEBPACK FOOTER //
// ./src/phoenix/services/clipboardService.ts